import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcToLocal',
    standalone: false
})
export class UtcToLocalPipe implements PipeTransform {
  transform(utcDateString: string, dateOrTime?: string): string {
    const invalidDate = 'Invalid Date';
    if(!utcDateString || typeof utcDateString !== 'string') return invalidDate
    const datePipe = new DatePipe('en-US');

    const formattedDate = utcDateString.endsWith("Z") || utcDateString.includes("+") ? utcDateString : utcDateString + "Z";
    const utcDate = new Date(formattedDate);
  
    if (!(utcDate instanceof Date) || isNaN(utcDate.getTime())) return invalidDate;
    const formats: Record<string, string> = {
      date: 'MM/dd/yyyy',
      time: 'h:mm:ss a',
      default: 'MM/dd/yyyy, h:mm:ss a'
    };
    
    return datePipe.transform(utcDate, formats[dateOrTime ?? 'default']) ?? 'Invalid Date';
  }
}
